import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Send, Loader2, Bot } from "lucide-react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { errMsg } from "./util";

export default function HabitsChat({ session, onSession }) {
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const end = useRef();
  const chat = session.chat || [];
  useEffect(() => { end.current?.scrollIntoView({ block: "nearest" }); }, [chat.length]);

  const send = async (text) => {
    const t = (text ?? msg).trim();
    if (!t) return;
    setBusy(true); setMsg("");
    onSession({ ...session, chat: [...chat, { role: "user", text: t }] });
    try { const { data } = await api.post(`/card-lens/sessions/${session.id}/chat`, { message: t }); onSession(data.session); setDone(data.done); }
    catch (e) { toast.error(errMsg(e, "Chat failed")); onSession(session); }
    setBusy(false);
  };

  return (
    <div className="rounded-2xl border border-stone-200 bg-white flex flex-col h-[380px]" data-testid="cl-habits-chat">
      <div className="flex-1 overflow-y-auto p-4 space-y-2.5">
        {chat.length === 0 && (
          <div className="text-sm text-stone-500" data-testid="cl-chat-empty">
            <Bot className="w-5 h-5 text-[#0B4D3A] mb-1" />I'll ask a few quick questions about how they spend each month. Rough numbers are fine.
            <div className="mt-3"><Button size="sm" onClick={() => send("Hi, help me find the best credit card")} className="rounded-full bg-[#0B4D3A] hover:bg-[#083B2D]" data-testid="cl-chat-start">Start the conversation</Button></div>
          </div>
        )}
        {chat.map((m, i) => (
          <div key={i} className={`flex ${m.role === "user" ? "justify-end" : ""}`}>
            <div className={`max-w-[80%] rounded-2xl px-3.5 py-2 text-sm ${m.role === "user" ? "bg-[#0B4D3A] text-white rounded-br-sm" : "bg-[#FBF8F1] text-stone-800 rounded-bl-sm"}`} data-testid={`cl-chat-msg-${i}`}>{m.text}</div>
          </div>
        ))}
        {busy && <div className="text-xs text-stone-400 flex items-center gap-1"><Loader2 className="w-3 h-3 animate-spin" /> thinking…</div>}
        {done && <div className="text-xs font-bold text-[#0B4D3A]" data-testid="cl-chat-done">Got enough to rank cards. The spends are filled in the form. Hit "Find best cards".</div>}
        <div ref={end} />
      </div>
      <form onSubmit={(e) => { e.preventDefault(); send(); }} className="border-t border-stone-200 p-2 flex gap-2">
        <Input value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="e.g. around 8k on Swiggy, fly twice a year…" className="rounded-full" data-testid="cl-chat-input" disabled={busy} />
        <Button type="submit" disabled={busy || !msg.trim()} className="rounded-full bg-[#0B4D3A] hover:bg-[#083B2D]" data-testid="cl-chat-send"><Send className="w-4 h-4" /></Button>
      </form>
    </div>
  );
}
